import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from '@tanstack/react-router';
import { Shell } from './layout/Shell';
export function AppShell() {
    return (_jsx(Shell, { children: _jsx(Outlet, {}) }));
}
